module.exports = __webpack_public_path__ + "img/dsci0099.b668c99c.jpg";